import { withAuthenticationRequired } from '@tom-ui/utils'
import { NonNumericReleaseFormControlPage } from '@tom-ui/planning'
import { renderIsoCodeMappingInputWithDetails } from '../IsoCodeMapping/IsoCodeMappingWrapper'

export const NNROrderControlWrapper = withAuthenticationRequired(() => {
  return (
    <NonNumericReleaseFormControlPage
      renderIsoCodeMappingInput={renderIsoCodeMappingInputWithDetails}
    />
  )
})
